var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.102 5h-13",
    stroke: "#213555",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.527 9.424a.6.6 0 01-.848 0l-4-4a.6.6 0 010-.848l4-4a.6.6 0 01.848.848L1.952 5l3.575 3.576a.6.6 0 010 .848z",
    fill: "#213555"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCgk8cGF0aCBkPSJNMTUuMTAxNiA1TDIuMTAxNTYgNSIgc3Ryb2tlPSIjMjEzNTU1IiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPg0KCTxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIg0KCQlkPSJNNS41MjczOSA5LjQyNDI2QzUuMjkzMDcgOS42NTg1OCA0LjkxMzE4IDkuNjU4NTggNC42Nzg4NiA5LjQyNDI2TDAuNjc4ODYxIDUuNDI0MjZDMC40NDQ1NDYgNS4xODk5NSAwLjQ0NDU0NiA0LjgxMDA1IDAuNjc4ODYxIDQuNTc1NzNMNC42Nzg4NiAwLjU3NTczM0M0LjkxMzE4IDAuMzQxNDE5IDUuMjkzMDcgMC4zNDE0MTkgNS41MjczOSAwLjU3NTczM0M1Ljc2MTcgMC44MTAwNDggNS43NjE3IDEuMTg5OTUgNS41MjczOSAxLjQyNDI2TDEuOTUxNjUgNUw1LjUyNzM5IDguNTc1NzNDNS43NjE3IDguODEwMDUgNS43NjE3IDkuMTg5OTUgNS41MjczOSA5LjQyNDI2WiINCgkJZmlsbD0iIzIxMzU1NSIgLz4NCjwvc3ZnPg==";
export { SvgIconArrowLeft as ReactComponent };